import { ENVIRONMENT } from "../environments/environment";

export const API_URL = ENVIRONMENT.API;

export const API_ROUTES = {
  getProfiles: `${API_URL}/user/{{userId}}/profiles`,
  createQuickscan: `${API_URL}/quickscans/{{dok}}`,
  getQuickscans: `${API_URL}/quickscans/{{dok}}`,
  getConfig: `${API_URL}/getConfig`,
  getUserInfo: `${API_URL}/users/me`,
  getMJOPReport: `${API_URL}/getPowerBiReport?version=2`,
  getActiveProfile: `${API_URL}/user/{{userId}}/profile`,
  getCustomers: `${API_URL}/getCustomers?version=1`,
  switchProfile: `${API_URL}/user/{{userId}}/profiles/switch`,
  getActiveProfileWithCustomer: `${API_URL}/users/profile/active`,
  healthCheck: `${API_URL}/doks/{{dok}}/health`,
  getMachineManagementConfig: `${API_URL}/machine-management`,
  getSourceTypes: `${API_URL}/ndok/vehicles/source_types`,
  createVehicle: `${API_URL}/ndok/vehicles`,
  updateVehicle: `${API_URL}/ndok/vehicles/{{uniqueId}}`,
  getVehicles: `${API_URL}/ndok/vehicles`,
  getDefaultVehicles: `${API_URL}/ndok/vehicles/default`,
};
